import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import Carousel from "nuka-carousel";
import ActionCreator from "../ActionCreator";
import * as Widget from "./Widget2/HeCafe";

const Stores = [
  { name: "store01.png" },
  { name: "store02.png" },
  { name: "store03.png" },
  { name: "store04.png" },
  { name: "store05.png" },
  { name: "store06.png" },
  { name: "store07.png" },
  { name: "store08.png" },
  { name: "store09.png" },
  { name: "store10.png" },
  { name: "store11.png" }
];

class StoresCarouselSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mount: false,
      itemPerRow: 5
    };
  }

  componentDidMount() {
    this.setState({ mount: true });
  }

  render() {
    let { navActions } = this.props;

    return (
      <Wrapper>
        <Widget.Row
          justify="space-between"
          css={`
            margin-bottom: 50px;
            max-width: 1035px;
            width: 100%;
            @media screen and (max-width: 600px) {
              margin-bottom: 30px;
              padding: 0px 30px;
              justify-content: center;
            }
          `}
        >
          <Widget.Container
            css={`
              width: 65px;
              @media screen and (max-width: 600px) {
                display: none;
              }
            `}
          />
          <Widget.SectionTitle haveMarginBottom={false}>
            嚴選品牌
          </Widget.SectionTitle>
          <Widget.SeeMoreButton
            label="探索更多"
            onClick={() => navActions.push("/stores")}
            css={`
              @media screen and (max-width: 600px) {
                display: none;
              }
            `}
          />
        </Widget.Row>
        <Widget.Container
          css={`
            max-width: 1220px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            @media screen and (max-width: 600px) {
              max-width: 600px;
            }
            @media screen and (max-width: 500px) {
              display: none;
            }
          `}
        >
          <Carousel
            slidesToScroll={"auto"}
            renderCenterLeftControls={this._renderLeftIcon}
            renderCenterRightControls={this._renderRightIcon}
            renderBottomCenterControls={this._renderBottomDots}
          >
            {this._reconstructItem().map((oneSlide, i) => (
              <OneSlide key={"stores-oneSlide" + i}>{oneSlide}</OneSlide>
            ))}
          </Carousel>
        </Widget.Container>

        <Widget.Container
          css={`
            margin-bottom: 25px;
            width: 100%;
            overflow-x: scroll;

            //hide scroll bar but keep funcationality
            scrollbar-width: none; //Firebox
            -ms-overflow-style: none; //IE and Edge
            ::-webkit-scrollbar {
              //Chrome, Safari and Opera
              display: none;
            }

            @media screen and (min-width: 501px) {
              display: none;
            }
          `}
        >
          <Widget.Container
            css={`
              width: 1485px; //it is a work around! >"<
              display: flex;
              justify-content: flex-start;
            `}
          >
            {Stores.map((s, idx) => (
              <Logo
                key={"store-mob-logo" + idx}
                src={`/images/pages/store/${s.name}`}
                css="margin: 10px 25px 20px 20px;"
              />
            ))}
          </Widget.Container>
        </Widget.Container>

        <Widget.SeeMoreButton
          label="探索更多"
          onClick={() => navActions.push("/stores")}
          css={`
            margin-top: 15px;
            @media screen and (min-width: 601px) {
              display: none;
            }
          `}
        />
      </Wrapper>
    );
  }

  _reconstructItem = () => {
    let { itemPerRow } = this.state;
    let result = [];

    Stores.forEach((s, idx, array) => {
      let element = (
        <Logo
          key={"store-desk-logo" + idx}
          src={`/images/pages/store/${s.name}`}
          css="margin: 10px 10px 40px;"
        />
      );

      if (idx % itemPerRow === 0) {
        result.push([element]);
      } else {
        let pushIndex = result.length - 1;
        result[pushIndex].push(element);
      }
    });

    return result;
  };

  _renderLeftIcon = ({ previousSlide }) => {
    let { mount } = this.state;
    if (mount && window.screen.width <= 600) {
      return false;
    }

    return (
      <IconContainer
        onClick={previousSlide}
        css="margin-left: 10px; transfrom: rotate(180deg); -webkit-transform: rotate(180deg); -moz-transform: rotate(190deg);"
      >
        <img
          src="/images/pages/landing/icon10.png"
          style={{ width: 20, height: 20 }}
        />
      </IconContainer>
    );
  };

  _renderRightIcon = ({ nextSlide }) => {
    let { mount } = this.state;
    if (mount && window.screen.width <= 600) {
      return false;
    }

    return (
      <IconContainer onClick={nextSlide}>
        <img
          src="/images/pages/landing/icon10.png"
          style={{ width: 20, height: 20 }}
        />
      </IconContainer>
    );
  };

  _renderBottomDots = ({ currentSlide }) => {
    return (
      <Widget.Row>
        {this._reconstructItem().map((item, i) => (
          <div
            key={"dot" + i}
            style={{
              margin: 10,
              width: currentSlide === i ? 8 : 6,
              height: currentSlide === i ? 8 : 6,
              borderRadius: "50%",
              background: currentSlide === i ? "#755B42" : "#DBCBBC"
            }}
          />
        ))}
      </Widget.Row>
    );
  };
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;

  @media screen and (max-width: 768px) {
    padding: 15px 0px;
  }
`;

const Logo = styled.img`
  width: 120px;
  height: 120px;

  @media screen and (max-width: 600px) {
    width: 90px;
    height: 90px;
  }

  ${props => props.css || ""};
`;

const OneSlide = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;

  :focus {
    outline: none;
  }
`;

const IconContainer = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  border: 0px;
  background-color: transparent;
  width: 40px;
  height: 40px;

  :focus {
    outline: none;
  }

  ${props => props.css || ""};
`;

export default connect(
  null,
  ActionCreator
)(StoresCarouselSection);
